<template>
  <div>

    <div class="mobile">
      <div class="d-inline-block">
        <v-select
          v-model="userOrderMode"
          :items="modeOptions"
          label="Bestellmodus wählen"
          outlined
          hide-details
          dense
        />
      </div>
    </div>

    <div class="tablet">
      <div class="lighten-3 rounded d-inline-block" style="transform: scale(1.2)">


        <v-btn-toggle
          v-model="userOrderMode"
          :mandatory="false"
          class="d-flex justify-center"
          rounded
        >
          <v-btn
            v-if="availableModes.includes('inhouse')"
            :value="'inhouse'"
            :class="{ 'active-mode': userOrderMode === 'inhouse' }"
          >
            🍽️ Zum Hier essen
          </v-btn>

          <v-btn
            v-if="availableModes.includes('takeAway')"
            :value="'takeAway'"
            :class="{ 'active-mode': userOrderMode === 'takeAway' }"
          >
            🥡 Zum Abholen
          </v-btn>

          <v-btn
            v-if="availableModes.includes('delivery')"
            :value="'delivery'"
            :class="{ 'active-mode': userOrderMode === 'delivery' }"
          >
            🚚 Zum Liefern
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>

  </div>

</template>

<script>
import {mapState, mapActions} from 'vuex';
import store from "../store/store";
import {getGlobalValue, setGlobalKeyValue} from "../util/globalState";
import {cloneMe} from "../vendor/util";
import {ebus} from "../vendor/ebus";

export default {
  name: 'OrderModeSwitcher',
  props: {
    availableModes: {
      type: Array,
      default: () => ['inhouse', 'takeAway', 'delivery'],
      validator: (modes) =>
        Array.isArray(modes) &&
        modes.every(mode => ['inhouse', 'takeAway', 'delivery'].includes(mode)),
    },
  },
  computed: {
    ...mapState(['selectedOrderModeByUser']),
    userOrderMode: {
      get() {
        return store.getters.selectedOrderModeByUser;
      },
      set(value) {
        store.commit('setSelectedOrderModeByUser', value);
        if (value) {
          this.$emit('selected');

          if (value !== 'inhouse') {
            let itemAndCount = getGlobalValue('userWantsToAddItemToCard');
            if (itemAndCount) {
              for (let i = 0; i < itemAndCount.count; i++) {
                let item = cloneMe(itemAndCount.item);
                store.commit('addItemToCart', {item: item});
              }
            }
          }

          if (value === 'inhouse') {
            //enable Inhouse
            setGlobalKeyValue('userSwitchedOrderMode', true);
            ebus.$emit('forceInhouseModus', {table: store.state.defaultInhouseTable});
          } else if (value === 'takeAway') {
            //enable takeAway
            ebus.$emit('clearInhouseModus', {eventSource: 'OrderModeSwitcher', usecase: value});
          } else if (value === 'delivery') {
            //enable delivery
            ebus.$emit('clearInhouseModus', {eventSource: 'OrderModeSwitcher', usecase: value});
          }

        }
      },
    },

    modeOptions() {
      const labels = {
        inhouse: '🍽️ Zum Hier essen',
        takeAway: '🥡 Zum Abholen',
        delivery: '🚚 Zum Liefern',
      };
      return this.availableModes.map(mode => ({
        value: mode,
        text: labels[mode],
      }));
    },

  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import '@/styles/base';

.v-btn-toggle .v-btn {
  min-width: 140px;
}

/* Style für aktiven Button */
.active-mode {
  background-color: $color-primary !important; /* Vuetify Primary */
  color: white !important;
  box-shadow: none !important; /* Entfernt den Schlagschatten */
}
</style>
